import { defaultMethodConfig } from "../utils/consts";
import { invokeAndLogDebugCode } from "./common";
/**
 * 生成空白方法
 * @param _options
 * @returns
 */
export function generateEmptyMethod(_options) {
  const code = `
async ( ) => {

}
  `;
  return {
    id: 'yourMethod',
    title: '自定义方法',
    args: [],
    code,
    ...defaultMethodConfig,
    debugCode: invokeAndLogDebugCode
  };
}
//# sourceMappingURL=empty.js.map
